export const NORMAL_BALANCE_ACCOUNT_DEBIT_UPPERCASE = 'D';
export const NORMAL_BALANCE_ACCOUNT_CREDIT_UPPERCASE = 'C';
